import { DeviceInfo } from '../DeviceInfo';

export class ExportStartEventArgs {
    public deviceInfo: DeviceInfo;
    public isCancelled: boolean = false;
    public format: string = '';

    constructor(deviceInfo: DeviceInfo, format: string) {
        this.deviceInfo = deviceInfo;
        this.format = format;
    }
}
